import { ConnectOptions, getVersionAutoSelect } from '../../connect'
import { miscUiState } from '../../globalState'
import { UTOPIA_SERVER_HOST } from '../../utopia/constants'
import { appStorage } from '../appStorageProvider'
import { getCurrentProxy } from '../ServersList'
import { utopiaAuthState } from './utopiaAuthState'
import { utopiaServerStatusState } from './utopiaServerStatus'

function getUtopiaServerAddress (): string {
  return miscUiState.appConfig?.utopiaServerHost?.trim() || UTOPIA_SERVER_HOST
}

/**
 * Proxy TCP pour le navigateur.
 * En auto-hébergement (defaultProxy vide), on laisse net-browserify utiliser
 * window.location → wss://utopia.csphere.fr/api/vm/net (Apache 443 → Node :1097).
 * Ne pas passer « :1097 » : cela devient https://utopia.csphere.fr:1097 (incorrect).
 */
function getUtopiaPlayProxy (): string | undefined {
  if (!miscUiState.appConfig?.defaultProxy?.trim()) {
    return undefined
  }
  return getCurrentProxy()
}

/** Connexion directe au serveur Utopie (sans liste de serveurs). */
export function connectToUtopiaServer (): boolean {
  if (utopiaServerStatusState.checked && utopiaServerStatusState.online !== true) return false
  const username = utopiaAuthState.user?.gameUsername ?? appStorage.username
  if (!username?.trim()) return false

  const connectOptions: ConnectOptions = {
    username: username.trim(),
    server: getUtopiaServerAddress(),
    proxy: getUtopiaPlayProxy(),
    botVersion: getVersionAutoSelect(),
    ignoreQs: true,
    saveServerToHistory: false,
  }
  window.dispatchEvent(new CustomEvent('connect', { detail: connectOptions }))
  return true
}
